import { Toaster as SonnerToaster } from 'sonner'

/** App-wide toast host — styled to match the design tokens in index.css rather than sonner's defaults. */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'rounded-md border shadow-raised font-sans text-sm items-center',
          title: 'text-ink font-medium',
          description: 'text-ink-muted',
          actionButton: 'bg-ink text-paper',
          cancelButton: 'bg-paper text-ink-muted',
          closeButton:
            'bg-paper border-line-strong text-ink-faint hover:text-ink',
          default: 'border-line-strong bg-paper-raised',
          success: 'border-success-soft bg-success-soft text-success',
          error: 'border-danger-soft bg-danger-soft text-danger',
          warning: 'border-warning-soft bg-warning-soft text-warning',
          info: 'border-primary-soft bg-primary-soft text-primary-hover',
        },
      }}
    />
  )
}
